<template>
    <div ref="queries" id="queries" class="border border-solid border-grey-light rounded relative overflow-hidden">

        <vs-sidebar class="items-no-padding" parent="#queries" :click-not-close="clickNotClose"
                    :hidden-background="clickNotClose" v-model="isQueriesSidebarActive">
            <QueriesSidebar></QueriesSidebar>
        </vs-sidebar>

        <div :class="{'sidebar-spacer': clickNotClose}"
             class="app-fixed-height border border-solid border-grey-light border-r-0 border-t-0 border-b-0">

            <div class="flex border items-center app-search-container relative" ref="queries-header">
                <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon"
                              @click.stop="toggleSidebar(true)"></feather-icon>
                <prism-editor v-model="code" language="sql" escape emitEvents style="max-height:200px;"
                              @keydown="disSend = true" @keyup="disSend = false" :disHighlight="!highlight"
                              class="vs-input-no-border vs-input-no-shdow-focus w-full no-icon-border"></prism-editor>
                <vs-button color="inherit" text-color="#000" icon-pack="feather" icon="icon-more-vertical"
                           class="absolute" style="top: 0; right: 16px" @click="showLog = !showLog"></vs-button>
            </div>

            <div class="flex flex-wrap justify-between p-4 border border-r-0 border-l-0 border-solid border-grey-light">
                <div class="flex">
                    <div>
                        <b>Conexão</b>
                        <div class="flex items-center">
                            <i-switch size="large" v-model="conexao" :false-value="0" :true-value="1">
                                <span slot="close">PG</span>
                                <span slot="open">PDO</span>
                            </i-switch>
                        </div>
                    </div>
                    <template v-if="isManager">
                        <div class="ml-10">
                            <b>Log</b>
                            <div class="flex">
                                <i-switch size="large" v-model="log"/>
                            </div>
                        </div>
                        <div class="ml-10">
                            <b>Validação</b>
                            <div class="flex">
                                <i-switch size="large" v-model="validation"/>
                            </div>
                        </div>
                        <div class="ml-10">
                            <b>Highlight</b>
                            <div class="flex">
                                <i-switch size="large" v-model="highlight"/>
                            </div>
                        </div>
                        <div class="ml-10">
                            <b>2FA</b>
                            <div class="flex">
                                <i-switch size="large" v-model="twoFactor"/>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="flex">
                    <div v-if="results.length > 0" class="flex items-center w-full">
                        <span class="flex items-center w-full">Resultados: {{results.length}}</span>
                    </div>
                    <vs-button color="warning" type="border" icon-pack="feather" icon="icon-shield"
                               class="w-full mr-2 relative" @click="showApprovals = true">
                        Aprovações
                        <span v-if="pendingCount > 0" class="badge-approvals">{{pendingCount}}</span>
                    </vs-button>
                    <vs-button :disabled="disSend" class="bg-primary-gradient w-full" icon-pack="feather"
                               icon="icon-send" @click="validateQuery">Executar
                    </vs-button>
                </div>
            </div>
            <vs-table class="table-queries" stripe search :data="results" :maxHeight="maxHeight">
                <template v-if="results.length > 0" slot="header">
                    <vs-button radius color="warning" icon-pack="feather" icon="icon-download" class="mx-4 px-5"
                               @click="generateCsv()"></vs-button>
                </template>
                <template slot="thead">
                    <vs-th v-for="(col, key) in columns" :key="key" :sort-key="col">{{col}}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td v-for="(col, key) in columns" :key="key">
                            <span v-if="data[indextr][col] && data[indextr][col].toString().length > 80">
                                {{data[indextr][col].substring(0, 80)}}
                                <a @click="detailColumn(col, data[indextr][col])"><b>...</b></a>
                            </span>
                            <span v-else>{{data[indextr][col]}}</span>
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </div>
        <drawer :closable="true" placement="right" title="Queries" v-model="showLog" width="550" class="drawer-queries">
            <i-input class="p-5" @input="searchDelay" placeholder="Pesquisar"/>
            <Collapse simple>
                <Panel name="1" class="my">
                    Minhas Queries
                    <ul class="collection" slot="content">
                        <li v-for="(query, i) in minhasQueries" :key="i">
                            <a @click="writeQuery(query.comando)">{{query.comando}}</a>
                        </li>
                    </ul>
                </Panel>
                <Panel name="2" class="others">
                    Outras
                    <ul class="collection" slot="content">
                        <li v-for="(query, i) in outrasQueries" :key="i">
                            <a @click="writeQuery(query.comando)"><span>~{{query.nome_pessoa_registro}}</span>{{query.comando}}</a>
                        </li>
                    </ul>
                </Panel>
            </Collapse>
        </drawer>
        <vs-prompt
                vs-buttons-hidden
                :vs-title="prompt.title"
                :vs-active.sync="prompt.show">
            <vs-textarea v-model="prompt.text" class="mt-3 w-full" height="400"/>
            <div class="flex justify-end">
                <vs-button @click="copyText">Copiar</vs-button>
            </div>
        </vs-prompt>

        <ApprovalsDrawer v-model="showApprovals" @executed="renderResult" @updated="pendingCount = $event"/>

        <Modal v-model="approvalRequest.show" title="Solicitar aprovação" ok-text="Enviar solicitação"
               cancel-text="Cancelar" @on-ok="sendApprovalRequest">
            <p class="mb-2">
                Comandos de escrita só são executados depois que outro usuário aprova.
                Descreva o que a query faz e por que precisa ser executada.
            </p>
            <pre class="request-command">{{approvalRequest.query}}</pre>
            <i-input type="textarea" :rows="4" v-model="approvalRequest.reason"
                     placeholder="Motivo da execução (mínimo 10 caracteres)"/>
        </Modal>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import debounce from "lodash/debounce"

    export default {
        name: "queries",
        data() {
            return {
                maxHeight: "500px",
                columns: [],
                results: [],
                conexao: 1,
                showLog: false,
                log: true,
                validation: true,
                code: '',
                isSidebarActive: false,
                showThread: false,
                clickNotClose: true,
                isQueriesSidebarActive: true,
                windowWidth: window.innerWidth,
                settings: {
                    maxScrollbarLength: 60,
                    wheelSpeed: 0.30,
                },
                search: '',
                minhasQueries: [],
                outrasQueries: [],
                prompt: {
                    show: false,
                    title: '',
                    text: ''
                },
                disSend: false, // Flag devido ao debounce do component
                highlight: true,
                // Só tem efeito para isManager: ligado exige aprovação, desligado executa direto
                twoFactor: true,
                showApprovals: false,
                pendingCount: 0,
                pendingInterval: null,
                approvalRequest: {
                    show: false,
                    query: '',
                    reason: ''
                }
            }
        },
        computed: {
            ...mapGetters('queries', ['query', 'selectedServer', 'selectedDB']),
            ...mapGetters(['isManager']),
        },
        methods: {
            handleWindowResize(event) {
                this.windowWidth = event.currentTarget.innerWidth;
                this.setSidebarWidth();
            },
            setSidebarWidth() {
                if (this.windowWidth < 992) {
                    this.isQueriesSidebarActive = this.clickNotClose = false;
                } else {
                    this.isQueriesSidebarActive = this.clickNotClose = true;
                }
            },
            setMaxHeight() {
                let headerHeight = this.$refs['queries-header'].clientHeight;
                let queriesHeight = document.body.clientHeight - headerHeight - 258;
                this.maxHeight = `${queriesHeight}px`;
            },
            closeViewSidebar() {
                this.isSidebarActive = false;
            },
            toggleSidebar(value = false) {
                if (!value) {
                    this.closeViewSidebar();
                    if (this.clickNotClose) {
                        return
                    }
                }
                this.isQueriesSidebarActive = value;
            },
            validateQuery: function () {
                let query = this.code.trim();
                if (query.length === 0) return;

                const comandos = this.listQueries(query);
                if (comandos.length === 0) return;

                /**
                 * Caso seja executado mais de um statement, altera a conexão para pg_connect
                 */
                if (comandos.length > 1) {
                    this.conexao = 0;
                }

                const regList = this.getRegList();

                if (this.validation && this.selectedServer !== 'homologbitis') {
                    for (let comando of comandos) {
                            const regex = new RegExp(regList.map(reg => reg.source).join("|"), "ig");
                            if (!regex.test(comando)) {
                                return this.$vs.notify({
                                    title: 'Query inválida',
                                    text: comando,
                                    color: "rgb(242,134,32)",
                                    icon: 'error',
                                    fixed: true,
                                    position: 'top-right'
                                });
                            }
                        comando = comando.toUpperCase();
                        if ((comando.includes("DELETE") || comando.includes("UPDATE")) && !comando.includes("WHERE")) {
                            return this.$vs.notify({
                                title: 'Erro',
                                text: "Query com UPDATE ou DELETE precisam conter WHERE",
                                color: "rgb(242,134,32)",
                                icon: 'error',
                                fixed: true,
                                position: 'top-right'
                            });
                        }
                    }
                }

                /**
                 * Escrita vira uma solicitação que outro usuário precisa aprovar. A gestão pode
                 * desligar o 2FA e executar direto, e nesse caso o servidor registra o bypass em
                 * log.query_approvals. Aqui é só conveniência — o servidor reclassifica a query e
                 * confere o cargo no banco, então não adianta burlar por aqui.
                 */
                if (this.needsApproval(comandos)) {
                    this.validQuery = '';

                    if (!this.isManager || this.twoFactor) {
                        this.approvalRequest = {show: true, query: this.code, reason: ''};
                        return;
                    }

                    this.selectPaginate = null;
                    // Escrita da gestão: caminho de statement e log sempre ligado no servidor
                    this.execQuery(this.code, false, true);
                    return;
                }

                const testSelect = comandos[0].toUpperCase();
                const paginavel = comandos.length === 1
                    && (testSelect.startsWith("SELECT") || testSelect.startsWith("EXPLAIN") || testSelect.startsWith("WITH"));

                if (paginavel && !query.endsWith("--") && !query.endsWith(";") && !query.toUpperCase().includes("LIMIT")) {
                    this.selectPaginate = {
                        query,
                        limit: 100,
                        offset: 0,
                    };
                    this.execPaginate();
                } else {
                    this.selectPaginate = null;
                    // Chegou aqui é leitura, então sempre pelo caminho de select do servidor
                    this.execQuery(this.code, true, this.log);
                }
                this.validQuery = query;

            },
            /**
             * Espelha SqlClassifier do backend (app/Domains/Queries/Utils/SqlClassifier.php).
             * Serve só para abrir o modal certo — quem decide de verdade é o servidor.
             */
            needsApproval(comandos) {
                const read = /^\(*\s*(SELECT|WITH|EXPLAIN|SHOW|TABLE|VALUES)\b/i;
                const write = /\b(INSERT|UPDATE|DELETE|MERGE|TRUNCATE|DROP|ALTER|CREATE|GRANT|REVOKE|COPY|CALL|DO|VACUUM|REINDEX|REFRESH|INTO)\b/i;

                return comandos.some(comando => {
                    // Sem o conteúdo das strings, para um 'DELETE' literal não virar comando
                    const stripped = comando.replace(/'(?:[^']|'')*'/g, "''").replace(/"(?:[^"]|"")*"/g, 'ident');

                    return !read.test(stripped.trim())
                        || write.test(stripped)
                        || /^\s*EXPLAIN\b[\s\S]*\bANALYZE\b/i.test(stripped)
                        || /\bFOR\s+(UPDATE|NO\s+KEY\s+UPDATE|SHARE|KEY\s+SHARE)\b/i.test(stripped);
                });
            },
            async sendApprovalRequest() {
                const {query, reason} = this.approvalRequest;

                if (!reason || reason.trim().length < 10) {
                    return this.$vs.notify({
                        title: 'Motivo obrigatório',
                        text: 'Descreva em pelo menos 10 caracteres por que a query precisa ser executada.',
                        color: "rgb(242,134,32)",
                        time: 10000,
                        position: 'top-right'
                    });
                }

                this.$vs.loading({scale: 0.6});
                try {
                    await this.$axios.post('queries/approvals', {
                        query,
                        connection_type: this.conexao,
                        server: this.selectedServer,
                        database: this.selectedDB,
                        reason
                    });
                    this.$vs.notify({
                        title: 'Solicitação enviada',
                        text: 'Aguardando aprovação de outro usuário.',
                        color: "#222222",
                        time: 10000,
                        position: 'top-right'
                    });
                } catch ({message}) {
                    this.$vs.notify({
                        title: 'Erro',
                        text: message,
                        color: "rgb(242, 19, 93)",
                        time: 10000,
                        position: 'top-right'
                    });
                }
                this.$vs.loading.close();
            },
            execPaginate() {
                const {query, limit, offset} = this.selectPaginate;
                const com = `${query} LIMIT ${limit} OFFSET ${offset}`;
                this.execQuery(com, true, this.log && offset === 0);
            },
            /**
             * Retorna um array de todas as queries que serão executadas
             * @return Array
             */
            listQueries(query) {
                return query
                    .split(/[\r\n]+/) // Array of break lines
                    .map(c => c.trim()).filter(Boolean)
                    .filter(c => !c.startsWith("--")) // Delete comments
                    .join(' ').match(/((?:(?:["'][^"']*["'])|[^;])+)/igm) // Split between semicolons
                    .map(c => c.normalize('NFD').replace(/[\u0300-\u036f]/g, "").trim()) // Remove accents/diacritics
                    .filter(Boolean);
            },
            getRegList() {
                // let reg = /(SELECT\s[\w\*\)\(\,\s]+\sFROM\s[\w]+)|(UPDATE\s[\w]+\sSET\s[\d\w]+[=\"\'\s\w\d\)\(\,]*\sWHERE\s[\d\w]+[=\"\'\s\w\d\)\(\,]*[\s]?=[\s]?)| (INSERT\sINTO\s[\d\w]+[\s\w\d\)\(\,]*\sVALUES\s\([\d\w\'\,\)]+)| (DELETE\sFROM\s[\d\w]+[\s\w\d\)\(\,]*\sWHERE\s[\d\w]+[=\"\'\s\w\d\)\(\,]*[\s]?=[\s]?)| (ALTER\s(TABLE|COLUMN)\s[\*\w]+)| (COMMENT\sON\sCOLUMN\s[\*\w]+)/ig;
                /**
                 * Para esses bancos update/insert devem possuir id_empresa
                 */
                if (['comercio', 'charm9', 'clini9'].includes(this.selectedDB)) {
                    return [
                        /(SELECT\s(?:(?:["'(][^"']*["'])|[^'"])*\sFROM\s[\w\.]+)/ig,
                        /(^(?!.*FROM)SELECT\s.*$)/igm,
                        /(UPDATE\s[\w\. ]+\sSET\s(?:(?:["'(][^"']*["'])|[^'"])*\sWHERE\s.*?(\bid_empresa\b)\s?(=\s?\d|(\bin\b)).*?)/ig,
                        /(DELETE\sFROM\s[\w\)\(\,\.\s]+\sWHERE\s.*?(\bid_empresa\b)\s?(=\s?\d|(\bin\b)).*?)/ig,
                        /(INSERT\sINTO\s[\w\.]+)/ig,
                        /(ALTER\s(TABLE|SCHEMA|COLUMN)\s[\w\.]+)/ig,
                        /(CREATE\s(TABLE|SCHEMA)\s[\w\.]+)/ig,
                        /(COMMENT\sON\sCOLUMN\s[\w\.]+)/ig,
                    ];
                }
                return [
                    /(SELECT\s(?:(?:["'(][^"']*["'])|[^'"])*\sFROM\s[\w\.]+)/ig,
                    /(^(?!.*FROM)SELECT\s.*$)/igm,
                    /(UPDATE\s[\w\. ]+\sSET\s(?:(?:["'(][^"']*["'])|[^'"])*\sWHERE\s[\d\w\.]*)/ig,
                    /(DELETE\sFROM\s[\w\)\(\,\.\s]+\sWHERE\s[\d\w\.]*)/ig,
                    /(INSERT\sINTO\s[\w\.]+)/ig,
                    /(ALTER\s(TABLE|SCHEMA|COLUMN)\s[\w\.]+)/ig,
                    /(CREATE\s(TABLE|SCHEMA)\s[\w\.]+)/ig,
                    /(COMMENT\sON\sCOLUMN\s[\w\.]+)/ig,
                ];
            },
            async execQuery(query, select, log) {
                this.$vs.loading({scale: 0.6});
                const servidor = this.selectedServer;
                const banco = this.selectedDB;
                const conexao = this.conexao;
                try {
                    const {data: {data, time}} = await this.$axios.post(`queries/exec/${servidor}/${banco}`, {
                        query,
                        conexao,
                        select,
                        log
                    });

                    if (this.selectPaginate && this.selectPaginate.offset > 0) {
                        if (data.length > 0) {
                            this.results = this.results.concat(data);
                        }
                    } else {
                        this.fillTable(data);
                    }
                    if (log) {
                        this.minhasQueries.unshift({
                            comando: query.replace(/LIMIT\s\d+\sOFFSET\s\d$/igm, "")
                        })
                    }
                    this.$vs.notify({
                        text: `Comando executado em ${time.toFixed(4)} ms`,
                        color: "#222222",
                        position: 'top-right'
                    });

                } catch ({message}) {
                    this.$vs.notify({
                        title: 'Erro',
                        text: message,
                        color: "rgb(242, 19, 93)",
                        time: 10000,
                        position: 'top-right'
                    });
                }
                this.$vs.loading.close();
            },
            fillTable(data) {
                this.columns = (data.length > 0) ? Object.keys(data[0]) : [];
                this.results = data;
            },
            /**
             * Resultado devolvido pela aprovação de outro usuário
             */
            renderResult({data}) {
                this.selectPaginate = null;
                this.fillTable(data);
                this.getQueries(this.search);
            },
            async countPending() {
                try {
                    const {data: {pending}} = await this.$axios.get('queries/approvals/count');
                    this.pendingCount = pending;
                } catch (e) {
                    // Contador é secundário: não interrompe o uso do console
                }
            },
            searchDelay: debounce(function (val) {
                if (this.search !== val) {
                    this.search = val;
                    this.getQueries(val);
                }
            }, 1000),
            async getQueries(search = "") {
                const servidor = this.selectedServer;
                const banco = this.selectedDB;
                if (!servidor || !banco) return;
                const {data: {minhas_queries, outras_queries}} = await this.$axios.get(`queries/list/${servidor}/${banco}?s=${search}`);

                this.minhasQueries = minhas_queries;
                this.outrasQueries = outras_queries;
            },
            writeQuery(query) {
                this.showLog = false;
                this.code = query;
            },
            detailColumn(title, text) {
                this.prompt = {
                    show: true,
                    title,
                    text
                };
            },
            copyText() {
                this.prompt.show = false;
                const text = this.prompt.text;
                this.$copyText(text).then(() => {
                    this.$vs.notify({
                        text: 'Texto copiado.',
                        color: 'success',
                        iconPack: 'feather',
                        position: 'top-right',
                        icon: 'icon-check-circle'
                    })
                }, () => {
                    this.$vs.notify({
                        text: 'Erro ao copiar texto.',
                        color: 'danger',
                        iconPack: 'feather',
                        position: 'top-right',
                        icon: 'icon-alert-circle'
                    })
                })
            },
            async generateCsv() {
                this.$vs.loading({scale: 0.6});
                const servidor = this.selectedServer;
                const banco = this.selectedDB;
                const query = this.validQuery;
                if (!query) return;
                try {
                    const {data: CSV} = await this.$axios.get(`queries/csv/${servidor}/${banco}`, {
                        params: {
                            query
                        },
                        responseType: 'blob'
                    });

                    let titulo = `${this.selectedDB}`.replace(/ /g, "_");

                    const blob = new Blob([CSV], {
                        type: "application/csv;charset=utf-8;"
                    });
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('style', 'visibility:hidden');
                    link.setAttribute('download', `${titulo}.csv`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch ({message}) {
                    this.$vs.notify({
                        title: 'Erro',
                        text: message,
                        color: "rgb(242, 19, 93)",
                        time: 10000,
                        position: 'top-right'
                    });
                }
                this.$vs.loading.close();
            },
            gerarCSV() {

                const columns = this.columns;
                let arrData = JSON.parse(JSON.stringify(this.results));
                let CSV = columns.join(";") + "\r\n";

                CSV += arrData.map(r => {
                    return columns.map(key => {
                        return r[key] !== null ? `"${String(r[key]).replace(/"/g, '""')}"`
                            : '""';
                    }).join(";");
                }).join("\r\n");

                let titulo = `${this.selectedDB}`.replace(/ /g, "_");

                const blob = new Blob([CSV], {
                    type: "application/csv;charset=utf-8;"
                });

                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.setAttribute('style', 'visibility:hidden');
                link.setAttribute('download', `${titulo}.csv`);

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            /**
             * Responsável pela paginação dos tickets quando alcança o fim da página
             */
            handleScroll: debounce(function (e) {
                const el = e.target.documentElement || e.target;
                if (!el.scrollHeight || !el.offsetHeight) return;
                let windowRelativeBottom = el.scrollHeight - el.offsetHeight;
                if ((el.scrollTop > windowRelativeBottom - 50) && this.selectPaginate && !(this.results.length % this.selectPaginate.limit)) {
                    this.selectPaginate.offset += this.selectPaginate.limit;
                    this.execPaginate();
                }
            }, 1000),
        },
        created() {
            this.code = this.query;
            this.$nextTick(() => {
                window.addEventListener('resize', this.handleWindowResize);
                this.tableQueries = document.querySelector('.table-queries .vs-table--tbody');
                if (this.tableQueries) {
                    this.tableQueries.addEventListener('scroll', this.handleScroll);
                }
            });
            this.setSidebarWidth();
            this.getQueries();
            this.countPending();
            this.pendingInterval = setInterval(this.countPending, 30000);
        },
        mounted() {
            this.setMaxHeight();
        },
        beforeDestroy: function () {
            window.removeEventListener('resize', this.handleWindowResize);
            if (this.tableQueries) {
                this.tableQueries.removeEventListener('scroll', this.handleScroll);
            }
            clearInterval(this.pendingInterval);
        },
        components: {
            QueriesSidebar: () => import('./components/QueriesSidebar'),
            PrismEditor: () => import('../../components/prism-editor/Editor.vue'),
            ApprovalsDrawer: () => import('./components/ApprovalsDrawer')
        },
        watch: {
            query(val) {
                this.code = val;
            },
            code() {
                this.setMaxHeight();
            },
            selectedServer() {
                this.getQueries();
            },
            selectedDB() {
                this.getQueries();
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/vuesax/apps/email.scss";
</style>

<style>
    #queries .email-scroll-area {
        height: 100%;
    }

    #queries .app-fixed-height {
        height: calc(100vh - 9rem);
    }

    #queries .vs-sidebar {
        z-index: 96 !important;
    }

    #queries .vs-sidebar--background {
        z-index: 95 !important;
    }

    .table-queries td {
        white-space: nowrap;
    }

    .badge-approvals {
        position: absolute;
        top: -6px;
        right: -6px;
        background: rgb(242, 19, 93);
        color: #fff;
        border-radius: 10px;
        padding: 0 6px;
        font-size: 11px;
        line-height: 18px;
    }

    .request-command {
        background: #f7f7f7;
        border-radius: 4px;
        padding: 8px;
        font-size: 12px;
        white-space: pre-wrap;
        word-break: break-word;
        max-height: 200px;
        overflow: auto;
        margin-bottom: 10px;
    }

    .table-queries .vs-table--thead th {
        background-color: #fff;
        position: sticky;
        top: 0;
        z-index: 1;
    }

    .drawer-queries .ivu-drawer-body,
    .drawer-queries .ivu-collapse-content,
    .drawer-queries .ivu-collapse-content-box {
        padding: 0;
    }

    .drawer-queries .my .ivu-collapse-header {
        color: #fff;
        background-color: rgba(var(--vs-success), 1) !important;
    }

    .drawer-queries .others .ivu-collapse-header {
        color: #fff;
        background-color: rgba(var(--vs-danger), 1) !important;
    }

    .collection a {
        display: block;
        -webkit-transition: 0.25s;
        -moz-transition: 0.25s;
        -o-transition: 0.25s;
        transition: 0.25s;
        color: rgba(var(--vs-primary), 1);
        background-color: #fff;
        line-height: 1.5rem;
        padding: 10px 20px;
        margin: 0;
        border-top: 1px solid #e0e0e0;
        position: relative;
    }

    .collection a:hover {
        background-color: #eee;
    }

    .collection a span {
        position: absolute;
        top: 0;
        right: 5px;
        font-size: 10px;
        color: #aaa;
    }
</style>
